import { z } from "zod";

const questionaireAnswersSchema = z.record(z.string(), z.unknown());
const requiredUnknownField = z.unknown().refine((value) => value !== undefined);

export const prospectSchema = z.object({
  submissionId: z.string(),
  submissionTime: z.number(),
  totalScores: z.number(),
  scores: z.record(z.string(), z.number()).optional(),
  projectName: requiredUnknownField,
  projectDeveloper: requiredUnknownField,
  email: requiredUnknownField,
  questionaireAnswers: questionaireAnswersSchema.optional(),
  prestoneId: z.string().optional(),
});

export const prospectListSchema = z.array(prospectSchema);

const prestoneProjectListSchema = z.object({
  data: z.array(
    z.object({
      latest: z.object({ prestoneId: z.string() }).optional(),
    }),
  ),
});

export type ParsedProspect = z.infer<typeof prospectSchema>;

export const parseProspectList = (value: unknown): ParsedProspect[] => {
  return prospectListSchema.parse(value);
};

export const parseProspect = (value: unknown): ParsedProspect => {
  return prospectSchema.parse(value);
};

export const parseProspectPrestoneId = (value: unknown): string | null => {
  return (
    prestoneProjectListSchema.parse(value).data[0]?.latest?.prestoneId ?? null
  );
};
